// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4030ccaf","940":"0a923069"}[chunkId] + ".chunk.js";
};